"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WorkbookTemplateDescription = exports.TemplateSelectMethods = void 0;
var React = require("react");
var widgets_1 = require("@tableau/widgets");
var Localize_1 = require("../../../gen-src/Localize");
var CreateTemplateFlow_1 = require("../../components/CreateTemplateFlow");
var WorkbookTemplateWidgetsStyles_1 = require("../../styles/WorkbookTemplateWidgetsStyles");
var JumpstartTelemetry_1 = require("../../telemetry/JumpstartTelemetry");
var AvailableDeviceLayouts_1 = require("./AvailableDeviceLayouts");
var TemplateSelectMethods;
(function (TemplateSelectMethods) {
    TemplateSelectMethods.Button = 'button';
    TemplateSelectMethods.Image = 'image';
})(TemplateSelectMethods = exports.TemplateSelectMethods || (exports.TemplateSelectMethods = {}));
var WorkbookTemplateDescription = /** @class */ (function (_super) {
    __extends(WorkbookTemplateDescription, _super);
    function WorkbookTemplateDescription(props) {
        var _this = _super.call(this, props) || this;
        // tslint:disable-next-line:no-empty
        _this.JumpstartTelemetry = new JumpstartTelemetry_1.JumpstartTelemetry(function () { });
        _this.disableButtons = function () {
            _this.setState({ buttonsDisabled: true });
        };
        _this.enableButtons = function () {
            _this.setState({ buttonsDisabled: false });
        };
        _this.onTemplateSelectedNonVpc = function () {
            _this.props.onTemplateSelected(_this.props.template.id, _this.props.template.connectionType.internalName, TemplateSelectMethods.Button);
        };
        _this.onTemplateSelectedVpc = function () {
            _this.disableButtons();
            _this.startCreateTemplateFlow();
            _this.enableButtons();
        };
        _this.handleUseDashboardButtonClick = function () {
            if (_this.props.sendTelemetry) {
                _this.props.sendTelemetry(_this.props.template, false);
            }
            if (_this.props.isVpc) {
                _this.onTemplateSelectedVpc();
            }
            else {
                _this.onTemplateSelectedNonVpc();
            }
        };
        _this.onTemplateCreated = function (success, url, createWorkbookInNewTab, windowReference) {
            // We need to take into considerations a few flows here since we want to support all browsers.
            // There are two flows that are calling to this method: creation of a template with sample data or creation of a template with user's data via sign in flow.
            // If we have reached this method from template creation with sample data then:
            //  - if the browser has pop up blocker detection then redirect the user to the workbook in a new tab that is in windowReference
            //  - if the browser doesn't have pop up blocker detection then redirect the user to the workbook in a new tab.
            // If we have reached this method from template creation with user's data then:
            //  - redirect the user without creating a new tab.
            if (createWorkbookInNewTab === void 0) { createWorkbookInNewTab = true; }
            if (windowReference === void 0) { windowReference = undefined; }
            if (windowReference) {
                if (success === true) {
                    windowReference.location.href = url;
                }
                else {
                    windowReference.close();
                }
            }
            else if (success === true) {
                if (createWorkbookInNewTab) {
                    window.open("" + window.location.origin + url, '_blank');
                }
                else {
                    window.location.href = "" + window.location.origin + url;
                }
            }
            if (success === false && _this.props.onTemplateCreationFailed) {
                _this.props.onTemplateCreationFailed();
            }
        };
        _this.getUseDashboardButton = function () {
            return (React.createElement("div", { className: WorkbookTemplateWidgetsStyles_1.WorkbookTemplateWidgetsStyles.ButtonDiv },
                React.createElement(widgets_1.ButtonWidget, { testId: "select-template-" + _this.props.template.id, children: Localize_1.Messages.SelectTemplateButtonText(), buttonType: widgets_1.ButtonType.Outline, handleClick: _this.handleUseDashboardButtonClick, title: Localize_1.Messages.SelectTemplateButtonText() })));
        };
        _this.descriptionNoButtons = function () {
            // TODO: fix this to get the values from the prop, need to convert string array to enum values.
            var hardcodedDevicesList = [AvailableDeviceLayouts_1.AvailableDevices.Laptop, AvailableDeviceLayouts_1.AvailableDevices.Phone];
            return (React.createElement(React.Fragment, null,
                React.createElement("div", { className: WorkbookTemplateWidgetsStyles_1.WorkbookTemplateWidgetsStyles.TemplateItemTitle }, Localize_1.Messages.DatasourceHeaderMessage()),
                React.createElement("div", { className: WorkbookTemplateWidgetsStyles_1.WorkbookTemplateWidgetsStyles.ConnectionType }, _this.props.template.connectionType.displayName),
                React.createElement("div", { className: WorkbookTemplateWidgetsStyles_1.WorkbookTemplateWidgetsStyles.TemplateItemTitle }, _this.props.template.name),
                React.createElement("div", { className: WorkbookTemplateWidgetsStyles_1.WorkbookTemplateWidgetsStyles.TemplateItemDescriptionText }, _this.props.template.description),
                React.createElement("div", { className: WorkbookTemplateWidgetsStyles_1.WorkbookTemplateWidgetsStyles.TemplateItemTitle }, Localize_1.Messages.LayoutsHeaderMessage()),
                React.createElement(AvailableDeviceLayouts_1.AvailableDeviceLayouts, { availableDevices: hardcodedDevicesList })));
        };
        _this.state = { buttonsDisabled: false };
        return _this;
    }
    WorkbookTemplateDescription.prototype.startCreateTemplateFlow = function () {
        var _this = this;
        // Create the template flow element on a stacked element
        // so that it will live on when this tab element is unmounted
        var container = new widgets_1.HostedStackedElementContainer();
        var createTemplateFlowProps = {
            initialShowSelectProject: true,
            initialWorkbookName: this.props.template.name,
            connectionType: this.props.template.connectionType,
            templateId: this.props.template.id,
            helpVersion: this.props.helpVersion ? this.props.helpVersion : '0.0.0.0',
            siteName: '',
            JumpstartTelemetry: this.JumpstartTelemetry,
            onTemplateCreated: function (success, editUrl, createWorkbookInNewTab, windowReference) {
                container.remove();
                _this.onTemplateCreated(success, editUrl, createWorkbookInNewTab, windowReference);
            },
            onCancel: function () {
                container.remove();
            },
            bypassConnectingDialog: false,
            isVpc: this.props.isVpc ? this.props.isVpc : false,
        };
        window.setTimeout(function () {
            container.render(React.createElement(CreateTemplateFlow_1.CreateTemplateFlow, __assign({}, createTemplateFlowProps)));
        }, 0);
    };
    WorkbookTemplateDescription.prototype.render = function () {
        // The list of available layouts is hardcoded for now. To be generalized with info returned by TAS
        return (React.createElement("div", { className: WorkbookTemplateWidgetsStyles_1.WorkbookTemplateWidgetsStyles.TemplateItemDescriptionDiv },
            this.descriptionNoButtons(),
            this.getUseDashboardButton()));
    };
    return WorkbookTemplateDescription;
}(React.Component));
exports.WorkbookTemplateDescription = WorkbookTemplateDescription;
//# sourceMappingURL=TemplateDescription.js.map